import { render, staticRenderFns } from "./b1.vue?vue&type=template&id=0a6106d0&scoped=true&"
import script from "./b1.vue?vue&type=script&lang=js&"
export * from "./b1.vue?vue&type=script&lang=js&"
import style0 from "./b1.vue?vue&type=style&index=0&id=0a6106d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6106d0",
  null
  
)

export default component.exports